import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchBusinessPrioritiesData } from '../../api'

export const requestBusinessPrioritiesData = createAsyncThunk(
  'businessPriorities/requestBusinessPrioritiesData',
  fetchBusinessPrioritiesData
)
